import Super from '../../core/button.gjs';
import styles from './secondary.module.scss';

const METADATA = {
  component: 'Spds::Action::Button::Secondary',
  description: `
    Secondary button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Secondary Button',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/action/button/secondary.gjs',
  },
};

export default class SpdsActionButtonSecondary extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-secondary';
  variantStyles = styles;
}

export const ACTION_BUTTON_SECONDARY_METADATA = SpdsActionButtonSecondary.metadata;
